
export default {
  props: {
    filters: {
      type: Boolean,
      default: false
    },
    itemsName: {
      type: String,
      default: 'signals'
    }
  },
  emits: ['clear']
}
